var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?de6470f7123b10c2a7885a20733e9cb1";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();



// WEBPACK FOOTER //
// ./src/assets/js/nbd_count.js